const types = {
  LOGIN_USER: "LOGIN_USER",
  LOGIN_SUCCESS: "LOGIN_SUCCESS",
  LOGIN_SUCCESS_NOTVERIFY: "LOGIN_SUCCESS_NOTVERIFY",
  LOGIN_ERROR: "LOGIN_ERROR",
  // new types
  CHECK_AVALIABLITY: "CHECK_AVALIABLITY",
  AVALIABLITY_SUCCESS: "AVALIABLITY_SUCCESS",
  AVALIABLITY_ERROR: "AVALIABLITY_ERROR",

  VERIFY_OTP: "VERIFY_OTP",
  VERIFY_OTP_SUCCESS: "VERIFY_OTP_SUCCESS",
  VERIFY_OTP_ERROR: "VERIFY_OTP_ERROR",

  RESEND_OTP: "RESEND_OTP",
  RESEND_OTP_SUCCESS: "RESEND_OTP_SUCCESS",
  RESEND_OTP_ERROR: "RESEND_OTP_ERROR",

  LOCATION: "LOCATION",
  // new types

  REGISTER_USER: "REGISTER_USER",
  REGISTER_SUCCESS: "REGISTER_SUCCESS",
  REGISTER_ERROR: "REGISTER_ERROR",
  REGISTER_COMPLETE: "REGISTER_COMPLETE",

  LOGOUT: "LOGOUT",

  VERIFY_USER: "VERIFY_USER",
  VERIFY_SUCCESS: "VERIFY_SUCCESS",
  VERIFY_ERROR: "VERIFY_ERROR",

  LOADING_START: "LOADING_START",
  LOADING_STOP: "LOADING_STOP",

  NOTIFY_UPDATE: "NOTIFY_UPDATE",
  CART_UPDATE: "CART_UPDATE",

  UPDATE_PROFILE: "UPDATE_PROFILE",

  SEARCH_VALUE: "SEARCH_VALUE",
  SEARCH_VALUE_ALL: "SEARCH_VALUE_ALL",

  SEARCH_KEYWORD: "SEARCH_KEYWORD",
  CLEAR_SEARCH: "CLEAR_SEARCH",
  AREA_VALUE: "AREA_VALUE",
  CITY_VALUE: "CITY_VALUE",
  SELECTED_TEST: "SELECTED_TEST",
  REMOVE_TEST: "REMOVE_TEST",
  CLEAR_TEST: 'CLEAR_TEST',
  REMOVEFEATURETEST: 'REMOVEFEATURETEST',
  GET_CITIES: 'GET_CITIES',
  CITIES_SUCCESS: 'CITIES_SUCCESS',
  CITIES_ERROR: 'CITIES_ERROR',
  GET_AREAS: 'GET_AREAS',
  AREAS_SUCCESS: 'AREAS_SUCCESS',
  AREAS_ERROR: 'AREAS_ERROR',
  GET_PARTNERS: 'GET_PARTNERS',
  PARTNERS_SUCCESS: 'PARTNERS_SUCCESS',
  PARTNERS_ERROR: 'PARTNERS_ERROR',
};

export default types;
